<template>
  <div class="main-questions-table">
    <el-tooltip placement="bottom" effect="light">
      <div slot="content" style="text-indent: 25px">
        <template v-for="mq in tooltips_mainQuestion"> {{ mq }} <br /> </template>
      </div>
      <el-button class="mb-4" size="small" type="primary" @click="openMainQuestionDialog">设置重点问题</el-button>
    </el-tooltip>
    <!-- 重点问题表格 -->
    <data-table
      ref="examine-main-data-table"
      align="center"
      :loading="loadingMainQs"
      :data="dataMainQsTable"
      :columns="mainColumns"
    >
      <template #media="{ row, $index }">
        <div class="demo-image__preview">
          <el-image
            style="width: 30px; height: 30px; margin-left: 5px"
            v-for="(m, index) in row.media"
            :src="m.imgUrl"
            :key="index"
            :preview-src-list="row.previewImgs"
          />
        </div>
      </template>
      <template #answerContent="{ row, $index }">
        <div v-if="row.qType === 14"><!-- 签名 -->
          <template v-for="(m, index) in row.answerContent">
            <el-image
              v-if="m"
              style="width: 30px; height: 30px; margin-left: 5px"
              :src="m"
              :key="index"
              :preview-src-list="row.previewSignImgs"
            />
            <span v-else>--</span>
          </template>
        </div>
        <div v-else-if="row.qType === 18"> <!-- 文件上传 -->
          <template v-for="(m, index) in row.answerContent">
            <el-image
              v-if="isImg(m)"
              style="width: 30px; height: 30px; margin-left: 5px"
              :src="m"
              :key="index"
              :preview-src-list="row.previewFileImgs"
            />
            <i v-else class="el-icon-document m-0 mr-1"></i>
            <a :href="isImg(m) ? 'javascript:;' : m" :download="m">{{
              ellipsisMiddle(getUrl(m), 3, 8)
            }}</a>
          </template>
        </div>
        <div v-else>{{ row.answerContent }}</div>
      </template>
      <!-- 空状态 -->
      <template slot="empty">
        <div class="my-6">
          <div class="text-theme-black-650 text-lg mb-3">还没有设置重点问题，可添加；也可以切换到“看全部问题”页签，审核完整答卷。</div>
          <el-button size="small" type="primary" @click="openMainQuestionDialog">设置重点问题</el-button>
        </div>
      </template>
    </data-table>
    <!-- 设置重点问题 弹层 -->
    <el-dialog
      class="mainQSDialog theme-dialog"
      title="设置重点问题"
      :visible.sync="mainDialogVisible"
      width="1100px"
      @close="closeEventMainDialog"
      destroy-on-close
      :append-to-body="true"
      ><!--  @opened="opened" -->
      <el-transfer
        style="text-align: left; display: inline-block"
        v-model="selectedMainQs"
        filterable
        :titles="['选择问题', '已选问题']"
        filter-placeholder="请输入题号/问题题干/题型"
        :data="questions"
      >
      </el-transfer>
      <div
        style="border-bottom: 1px solid #dcdfe6; width: 100%; margin: 15px 0;"
      ></div>
      <el-row type="flex" justify="center" :gutter="20" style="marigin: -10px 0">
        <el-col style="text-align: right"
          ><el-button @click="cancelMainDialog" style="width: 100px">取消</el-button></el-col
        >
        <el-col style="text-align: left"
          ><el-button
            style="width: 100px"
            type="primary"
            @click="confirmMainDialog"
            :disabled="isequal(sortby(selectedMainQs_bak), sortby(selectedMainQs))"
            >确定</el-button
          ></el-col
        >
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { typeMapping } from '@dygc/question'
import isequal from 'lodash.isequal'
import sortby from 'lodash.sortby'
import GlobalConfig from '@/global/config'
import { convertAnswerText } from '@/question/convert.js'
import { queryQCDetailById, getMainQuestionsById, resetMainQuestions } from '@/api/wenjuan/qualityControl'
import DataTable from '@/components/base/DataTable'
import { mainColumns } from '@/components/survey-detail/config/columns.js'
import { getStore } from '@dygc/shared'
import { getSurveyById } from '@/api/survey'
import { convertQuestionList, filterQuestionByType } from '@/question/factory'
import { ellipsisMiddle } from './detailMeans.js'
import mixins from './mixins' // 待优化
export default {
  mixins: [mixins],
  name: 'MainQuestionsTable',
  components: {
    DataTable
  },
  props: {
    currentId: String,
  },
  data() {
    return {
      mainColumns,
      mainDialogVisible: false,
      selectedMainQs: [], // 已选中 重点题
      selectedMainQs_bak: [], // 备份
      questions: [], // 当前问卷所有题
      dataMainQsTable: [], // table数据
      answerData: [], // 所有答案
      loadingMainQs: false, // table loading
      tooltips_mainQuestion: [
        '当不需要审核所有问题，或',
        '想要重点审核某些问题时，可在',
        '这里进行设置。（该设置仅对自',
        '己可见，不影响其他用户）'
      ],
      clickedConfirmed: false // 是否点击 穿梭框的 确定
    }
  },
  methods: {
    isequal, sortby, ellipsisMiddle,
    // 获取重点问题 与登录人有关；和执行人切换无关
    getMainQuestions() {
      this.loadingMainQs = true
      return getMainQuestionsById(GlobalConfig.getSurveyId()).then(res => {
        const data = (res.data && res.data.data) || []
        // 已选重点问题
        this.selectedMainQs = data.map(item => {
          return item.id
        })
        // 备份 用于 弹框点击 取消的 回退赋值
        this.selectedMainQs_bak = JSON.parse(JSON.stringify(this.selectedMainQs))
      }).finally(() => {
        this.loadingMainQs = false
      })
    },
    // 确定
    confirmMainDialog() {
      // 标记是否点了 确定 用于穿梭框交互
      this.clickedConfirmed = true
      resetMainQuestions({
        surveyId: GlobalConfig.getSurveyId(),
        questionIds: this.selectedMainQs
      })
        .then(res => {
          this.mainDialogVisible = false
          // 备份 用于 弹框点击 取消的 回退赋值
          this.selectedMainQs_bak = JSON.parse(JSON.stringify(this.selectedMainQs))
          // 查询数据
          this.queryMainData()
        })
        .catch(e => {
          // 恢复之前选中的结果
          this.selectedMainQs = this.selectedMainQs_bak
          this.$message.error(e.message || '设置重点问题失败')
        })
        .finally(() => {
          this.clickedConfirmed = false
        })
    },
    // 点击‘设置重点问题’按钮
    openMainQuestionDialog() {
      this.mainDialogVisible = true
    },
    // 取消
    cancelMainDialog() {
      this.mainDialogVisible = false
    },
    closeEventMainDialog() {
      // 点确定以外的操作
      if (!this.clickedConfirmed) {
        // 恢复之前选中的结果
        this.selectedMainQs = this.selectedMainQs_bak
      }
    },
    _getImgUrl(imgUrl) {
      if (imgUrl.startsWith('/')) {
        imgUrl = imgUrl.slice(1)
      }
      return imgUrl ? window.location.origin + '/fill/api/v1/download?fileName=' + imgUrl : ''
    },
    // 根据不同题型 返回 题选项 ；暂时不用
    _getQItemByQType(issue, qType) {
      switch (qType) {
        case 1:
          return (
            issue.items &&
            issue.items
              .map(item => {
                return item.content.text
              })
              .join('，')
          )
          break
        default:
      }
    },
    // 根据不同题型 返回 答案
    _getAnswerByQType(items, qType, issue) {
      // todo t最后一道题 隐藏了一个 questionType = 20的题，不知道接口是否会返回；如何显示
      // todo 签字题 如何显示
      // todo app pc答案存放不一样
      switch (qType) {
        case 4: // 填空题
          const v =
            items &&
            items
              .map(item => {
                return item.value
              })
              .join('，')
          return {
            answerContent: v ? (issue.fillText === '_' ? v : issue.fillText + ' | ' + v) : ''
          }
          break
        case 5: // 矩阵单选
        case 6: // 矩阵多选
          return {
            answerContent:
              (items &&
                items
                  .map(item => {
                    // app
                    if (item.optionId) {
                      return item.optionId + '：' + item.value
                      // pc
                    } else {
                      return item.value
                    }
                  })
                  .join('，')) ||
              ''
          }
          break
        case 10: // NPS量表题
        case 9: // 矩阵量表题
          return {
            answerContent:
              (items &&
                items
                  .map(item => {
                    return item.value
                  })
                  .join('，')) ||
              ''
          }
          break
        case 3: // 级联题
          return {
            answerContent:
              (items &&
                items
                  .map(item => {
                    return item.value
                  })
                  .join('/')) ||
              ''
          }
          break
        case 112: // 可下载附件
          return {
            answerContent: '（这是可下载附件题）'
          }
          break
        case 20: // 描述题
          return {
            answerContent: '（这是描述题）'
          }
          break
        case 14: // 手写签名 //'（这是手写签名题）'
          const pics =
            (items &&
              items.map(item => {
                return this._getImgUrl(item.value)
              })) ||
            []
          return {
            answerContent: pics,
            otherParams: {
              previewSignImgs: pics
            }
          }
          break
        case 18: // 文件上传
          const arrs = items && items.map(item => {
            if(this.isImg(item.value)) {
              return this._getImgUrl(item.value)
            } else {
              return this._getDownloadUrl(item.value)
            }
          })
          // 先找出图片的文件
          const picsArr = arrs.filter(item => {
            if(this.isImg(item)) {
              return item
            }
          })
          // 找出文件
          const filesArr = arrs.filter(item => {
            if(!this.isImg(item)) {
              return item
            }
          })
          return {
            answerContent: arrs,
            otherParams: {
              previewFileImgs: picsArr,
              previewFiles: filesArr
            }
          }
          break
        case 1: // 单选题
        case 2: // 多选题
        case 12: // 下拉题-单选
        case 13: // 下拉题-多选
        case 7: // 单行文本
        case 8: // 多行文本
        case 11: // 排序题
        case 21: // 单行量表
        case 105: // 多项填空
        case 106: // 矩阵下拉
        case 113: // 图片选择
        case 111: // 分类题
        case 107: // 矩阵填空
        case 15: // 自定义单行量表题
        case 16: // 自定义多行量表题
        default:
          return {
            answerContent:
              (items &&
                items
                  .map(item => {
                    return item.value
                  })
                  .join('，')) ||
              ''
          }
          break
      }
    },
    isImg(url) {
      //文件路径
      var fileName = url
      //后缀获取
      let suffix = ''
      // 获取类型结果
      let result = ''
      const flieArr = fileName.split('.')
      suffix = flieArr[flieArr.length - 1]
      if (suffix != '') {
        suffix = suffix.toLocaleLowerCase()
        // 图片格式
        const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
        // 进行图片匹配
        result = imglist.find(item => item === suffix)
        if (result) {
          return true
        } else {
          return false
        }
      }
    },
    getUrl(item) {
      const index = item.lastIndexOf('/')
      return item.slice(index + 1)
    },
    _handleMainQsTable(data) {
      let list = []
      // 如果无重点题，this.questions === 0 list = []
      if (this.questions && this.questions.length === 0) {
        list = []
      } else {
        list = data.answerContent.map((item, idx) => {
          // item.questionDetails 题
          // item.items 答案
          /**
           * 处理逻辑：有题目按题目（各种题型）展示，没有答案，也会显示题目
           * 1.没有题目的返回null
           * 2.有题目: 没有在重点题里 返回null
           **/
          const qDetails = item.questionDetails
          if (qDetails) {
            const id = qDetails.id // 题id
            // const contentText = qDetails.content.text || '' // 题标题
            // 按照 穿梭框内容显示题干
            // const contentText = this.questions.find(q => q.key === id).labelTable || ''
            // 转换 引用题
            const contentText = convertAnswerText(qDetails.content.text, this.answerData.answerContent)
            const issue = qDetails.issue // 题 选项
            const qType = qDetails.questionType // 题型
            const qItems = item.items // 答案
            // 整理 大图预览
            const previewImgs =
              (item.photoFiles &&
                item.photoFiles.map(item => {
                  return this._getImgUrl(item)
                })) ||
              []
            // 整理 多媒体展示图片
            const imgFiles =
              (item.photoFiles &&
                item.photoFiles.map((item, idx) => {
                  return {
                    num: idx,
                    text: '图片',
                    name: data.surveyTitle + '图片' + data.id,
                    imgUrl: this._getImgUrl(item)
                  }
                })) ||
              []
            // 从当前所有题里 找出 对应题号
            const ques = this.questions.find(item => {
              return item.key === id
            })
            // 如果this.questions > 0 ，查询不到ques的话，返回null
            if (this.questions && this.questions.length > 0 && !ques) {
              return null
            }
            // 根据类型 返回答案
            const { answerContent, otherParams } = this._getAnswerByQType(qItems, qType, issue)
            return {
              id: id, // 问卷id
              num: (ques && ques.num) || idx + 1, // 题号
              text: contentText, // 题干
              // answerNum: 'todo', // 答题序号
              // questionItem, // 题目的选项
              answerContent, // 答案内容 todo不同题型
              ...otherParams,
              media: imgFiles, // 多媒体(图片)
              previewImgs, // 预览
              qType // 题型
            }
          } else {
            return null
          }
        })
      }
      // 过滤掉 等于null的情况
      list = list.filter(item => {
        return item
      })
      return list
    },
    queryMainData() {
      queryQCDetailById({
        answerId: this.currentId,
        onlyMainQuestions: true, // 只返回重点项目设置的题
        preAudit: getStore({name: 'proxy_is_survey_proxy'}) // 2021-1-25 委托代理
      })
      .then(res => {
        const data = (res.data && res.data.data) || []
        // 先整理数据再显示
        this.dataMainQsTable = this._handleMainQsTable(data)
        // 保存审核状态 返回给父组件
        const { status, audited, allowModifyAnswers, procTaskId } = data
       /*  // 设置当前审核的流程任务id
        this.currentProcTaskId = data.procTaskId
        // 判断是否已审核过
        this.audited = data.audited
        // 判断是否可编辑
        this.isCanEdit = data.allowModifyAnswers */
        const auditStatus = { status, audited, allowModifyAnswers, procTaskId } 
        // 获取各种状态（答卷状态，是否可以编辑等）
        this.$emit('getStatus', auditStatus)
      })
      .catch(e => {
        this.$message.warning(e.message || '当前问卷已经被审核，请重新选取新的答卷')
        if (e.message !== '系统未知错误,请反馈给管理员' && e.message !== '该答卷已被审核') {
          // this.getTableData(this.isActive) // 刷新列表
        }
      })
    },
    // 查询所有答案
    queryAnswerData(callback) {
      queryQCDetailById({
        answerId: this.currentId,
        onlyMainQuestions: false, // 返回全部题
        preAudit: getStore({name: 'proxy_is_survey_proxy'}) // 2021-1-25 委托代理
      })
      .then(res => {
        const data = (res.data && res.data.data) || []
        this.answerData = data
        if(data.channel === 12) {
          this.$emit('notCopy')
        }
        callback && callback()
      })
    },
    // 处理 问卷题目 在穿梭框的显示数据格式
    handleWjList(n) {
      // 整理 当前题型数据 用于穿梭框
      // 清除分页的null
      const list = n.filter(res => {
        return res.id
      })
      this.questions = list.map((item, idx) => {
        return {
          label: idx + 1 + '.' + item.content.text + '【' + typeMapping.get(item.question_type) + '】', // 穿梭框中显示
          // labelTable: item.content.text + '【' + typeMapping.get(item.question_type) + '】',// 列表显示
          key: item.id,
          disabled: false,
          num: idx + 1
        }
      })
    },
  },
  computed: {
    ...mapGetters(['questionList'])
  },
  watch: {
    currentId(n) {
      // 注意先后顺序
      this.queryAnswerData(this.queryMainData)
    }
  },
  created() {
    // 页面切换时 处理questionList（当前问卷的所有题型）（穿梭框左侧）
    getSurveyById(GlobalConfig.getSurveyId()).then(res => {
      const data = res.data.data
      let list = data.pageQuestions
      let logics = data.logics || []
      const questionList = convertQuestionList(filterQuestionByType(list, 1), logics)
      this.handleWjList(questionList)
      this.getMainQuestions()
      // 注意先后顺序
      setTimeout(() => {
        this.queryAnswerData(this.queryMainData)
      })
    })
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-transfer-panel {
  width: 470px;
}
::v-deep .el-transfer {
  display: flex !important;
  justify-content: center;
  .el-transfer__buttons {
    // padding: 0 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .el-button--primary,
    .is-disabled {
      margin-top: -40px;
      margin-left: 9px;
    }
  }
}
// 交换两个按钮位置和样式
::v-deep .el-icon-arrow-left:before {
  // color: rgb(145, 191, 255);
}
::v-deep .el-transfer__buttons {
  button:first-child {
    position: absolute;
    bottom: 195px;
    // background: white;
  }
}
</style>
